import React, { FC } from "react";
import { Modal } from "react-bootstrap";
import { useOnboarding } from "../../../context/OnboardingContext";
import OnboardingWizard from "./OnboardingWizard";

const WizardModal: FC = () => {
  const { isOpen, mode, closeWizard } = useOnboarding();

  if (mode !== "modal") return null;

  return (
    <Modal
      show={isOpen}
      onHide={closeWizard}
      centered
      size="xl"
      dialogClassName="b2c-wizard-modal"
    >
      <Modal.Body style={{ padding: 0 }}>
        <OnboardingWizard onClose={closeWizard} />
      </Modal.Body>
    </Modal>
  );
};

export default WizardModal;
